var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loader)?_c('ILoader'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }